import { Box, Button, Input, Stack } from "@chakra-ui/react";
import React, { useMemo, useState } from "react";
import { Building, useBuildings } from "../../data/occupancy.api";
import QueryStateWrapper from "../QueryStateWrapper";
import ReactGA from "react-ga4";

type Props = {
  value?: Building;
  onChange: (building: Building) => void;
};

const BuildingSelector = ({ value, onChange }: Props) => {
  const { data, isLoading, error } = useBuildings();
  const [searchQuery, setSearchQuery] = useState("");

  const results = useMemo(() => {
    return data
      ?.filter((building) => {
        return building.name.toLowerCase().includes(searchQuery.toLowerCase());
      })
      .sort((a, b) => a.name.localeCompare(b.name));

    // console.log(data);
  }, [data, searchQuery]);

  return (
    <QueryStateWrapper data={data} isLoading={isLoading} error={error}>
      <Input
        variant="filled"
        mb={2}
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        placeholder="Search"
      />
      <Box maxH={"400px"} overflowY="auto">
        <Stack>
          {results?.map((building) => (
            <Button
              onClick={() => {
                ReactGA.event({
                  category: "user_interaction",
                  action: `selected ${building} in bookings`,
                });
                onChange?.(building);
              }}
              colorScheme={
                building.key === value?.key ? "lancsBlue" : undefined
              }
            >
              {building.name}
            </Button>
          ))}
        </Stack>
      </Box>
    </QueryStateWrapper>
  );
};

export default BuildingSelector;
